var responsiveToolkit = require('src/interlock/no-ui/utils/responsive-bootstrap-toolkit/responsive-bootstrap-toolkit'),
    constant = require('./constant');

var SPONSORED_AD_TEMPLATE = {
    WIRED: 'aag-ad-wired',
    MOBILE: 'aag-ad-mobile'
};

var EventHandlersHelper = function() {
    var aagCarousel = document.querySelector('.at-a-glance-carousel-wrapper');
    var web503 = ($('.image-type-selector').data('abtest') === 'web-503');

    return {
        getCurrentDataIndex: function(cb) {
            // Yeah, I have to make a setTimeout because the changed.owl.carousel happens after the fact.
            // So yeah. If you can think of a better way, lets try
            setTimeout(function() {
                var currentIndex, activeItem;
                //var allItemsLength = getLength(aagCarousel.querySelectorAll('.owl-item'));
                if (aagCarousel) {
                    activeItem = aagCarousel.querySelector('.owl-item.active');
                }
                if (activeItem) {
                    currentIndex = parseInt(activeItem.querySelector('.item').getAttribute('data-index'), 10);
                }
                cb(currentIndex);
            }, 10);
        },

        createSlide: function(photoObj, useImageService, slotIndex) {
            var photoSizes = photoObj.photoSizes,
                elItem = document.createElement('div'),
                elCarouselItem = document.createElement('div'),
                photoToUse,
                sizeWeNeed = photoSizes.reduce(function (photoIndexToUse, photoSize, index) {
                    if (photoSize == photoObj.originalWidth || photoSize === constant.DEFAULT_PHOTO_SIZE) {
                        photoIndexToUse = index;
                    }
                    return photoIndexToUse;
                }, 0);

            photoToUse = photoObj.photoSrcs[sizeWeNeed];
            if (useImageService) {
                photoToUse = 'https://services.edmunds-media.com/image-service/media-ed/sharp/' +
                    '?crop=16x7&quality=70&format=jpg:progressive&image=' + photoToUse;
            }
            elItem.classList.add('item');
            elItem.setAttribute('data-index', slotIndex);
            elCarouselItem.classList.add('carousel-image');
            elCarouselItem.setAttribute('data-selenium', slotIndex);
            elCarouselItem.setAttribute('data-alt', photoObj.captionTranscript);
            elCarouselItem.style.backgroundImage = 'url(' + photoToUse + ')';
            elItem.appendChild(elCarouselItem);
            if (aagCarousel.querySelector('.sponsored-ad-templates').children.length) {
                elItem.appendChild(this.createRandomAdUnit());
            }
            $(elItem).append(constant.ARROW_HANDLER.join(''));
            $(elItem).find('.punit').asyncGptTag({});
            return elItem;
        },

        createRandomAdUnit: function() {
            var lengthOfSponsoredAds = $('.sponsored-ad-templates .dub-ad-wrapper').length || 0;
            // divides by 2 because it appends both mobile and wired ad.
            var randomSlot = Math.floor(Math.random() * (lengthOfSponsoredAds / 2) + 0);
            var selector = '.sponsored-ad-templates .spon-ad-' + randomSlot;
            if(responsiveToolkit.is('<=sm')) {
                selector += '.' + SPONSORED_AD_TEMPLATE.MOBILE;
            } else {
                selector += '.' + SPONSORED_AD_TEMPLATE.WIRED;
            }
            var dubAdWrapper = document.createElement('div');
            dubAdWrapper.classList.add('dub-ad-wrapper', 'p-a-0_5');
            var adElement = aagCarousel.querySelector(selector).cloneNode(true);
            if (adElement) {
                dubAdWrapper.appendChild(adElement);
            }
            return dubAdWrapper;
        },

        createFilterLink: function(data, count) {
            var anchor = document.createElement('a');
            anchor.setAttribute('data-image-type', data);
            anchor.href = '#';
            if(web503) {
                var div = document.createElement('div');
                div.appendChild(anchor);
                var imgDiv = document.createElement('div');
                imgDiv.classList.add('dark-over');
                imgDiv.classList.add(data);
                var span = document.createElement('span');
                span.innerHTML = data;
                span.classList.add(data+'-span');
                span.classList.add('filter-text');
                span.innerHTML = data + ' ('+count+')';
                anchor.appendChild(imgDiv);
                anchor.appendChild(span);
                anchor.classList.add(data+'-wrapper');
                return div;
            }
            anchor.innerHTML = data;

            return anchor;
        },

        addAllLink: function(cats, count){
            if(web503){
                cats.appendChild(this.createFilterLink('all', count));
            }
        },

        web503Helper: function(aagcData, cats, data){
            if(!web503){
                cats.appendChild(this.createFilterLink(aagcData.CATEGORY_HOME));
            }
            var count = 0;
            for(var cat in data) {
                if(data[cat]) {
                    count += data[cat];
                    if(web503 && cat === 'interior'){
                        $(cats).prepend(this.createFilterLink(cat, data[cat]));
                    } else {
                        cats.appendChild(this.createFilterLink(cat, data[cat]));
                    }
                }
            }
            this.addAllLink(cats, count);
        },

        populateTypeFilter: function(aagcData, cats, data) {
            if(cats) {
                this.web503Helper(aagcData, cats, data);
            }
        }
    };
};
module.exports = new EventHandlersHelper();



//////////////////
// WEBPACK FOOTER
// ./src/creative/core-page/at-a-glance-carousel/at-a-glance-carousel-event-handlers-helpers.js
// module id = 143
// module chunks = 0 1 27